export class CerRandom {
    public static AsString(numChars : number = 10) : string {
        var n = Math.min(numChars,10);
        const s = Math.trunc(Math.random()*Math.pow(10, n)).toFixed(0).substring(0,n);
        return s;
    }
}